// Errores de /api/oficina en cristiano (revisión S5a, M7): nunca se enseña a Pau el mensaje crudo del
// servidor (que para un formulario inválido es la lista técnica de zod). Cada código tiene su texto.
import { t } from '../../i18n';
import { ApiHttpError } from '../../lib/api';

const TEXTO = {
  FORMULARIO_INVALIDO: 'oficinaV2.errores.FORMULARIO_INVALIDO',
  DATOS_INVALIDOS: 'oficinaV2.errores.DATOS_INVALIDOS',
  PROYECTO_NO_HABILITADO: 'oficinaV2.errores.PROYECTO_NO_HABILITADO',
  SALA_LLENA: 'oficinaV2.errores.SALA_LLENA',
  SIN_RUNNER_CAPAZ: 'oficinaV2.errores.SIN_RUNNER_CAPAZ',
  // Justo después de reiniciar el panel, hasta que los servidores mandan su lectura de uso (≈1 min).
  CAPACITY_UNKNOWN: 'oficinaV2.errores.CAPACITY_UNKNOWN',
  NOMBRE_OCUPADO: 'oficinaV2.errores.NOMBRE_OCUPADO',
  // WS15-D4 — esa parte ya la tiene otro agente vivo: se amplía aquel en vez de contratar a otro.
  ZONA_OCUPADA: 'oficinaV2.errores.ZONA_OCUPADA',
  PARECE_UNA_CLAVE: 'oficinaV2.errores.PARECE_UNA_CLAVE',
  CLAVE_USADA: 'oficinaV2.errores.CLAVE_USADA',
  SIN_CONTRATO: 'oficinaV2.errores.SIN_CONTRATO',
  VERSION_DESFASADA: 'oficinaV2.errores.VERSION_DESFASADA',
  CONTRATO_YA_RESPONDIDO: 'oficinaV2.errores.CONTRATO_YA_RESPONDIDO',
  RESPUESTAS_INCOMPLETAS: 'oficinaV2.errores.RESPUESTAS_INCOMPLETAS',
  PREGUNTA_YA_RESPONDIDA: 'oficinaV2.errores.PREGUNTA_YA_RESPONDIDA',
  NO_ES_DE_LA_OFICINA: 'oficinaV2.errores.NO_ES_DE_LA_OFICINA',
  NO_SE_PUEDE_CERRAR: 'oficinaV2.errores.NO_SE_PUEDE_CERRAR',
  NO_ESTA_ATASCADO: 'oficinaV2.errores.NO_ESTA_ATASCADO',
  NO_SE_PUEDE: 'oficinaV2.errores.NO_SE_PUEDE',
  PERMISO_YA_RESPONDIDO: 'oficinaV2.errores.PERMISO_YA_RESPONDIDO',
  PERMISO_AUN_NO: 'oficinaV2.errores.PERMISO_AUN_NO',
  CONTRATADO_CERRADO: 'oficinaV2.errores.CONTRATADO_CERRADO',
  PERMISO_NO_VALIDO: 'oficinaV2.errores.PERMISO_NO_VALIDO',
  AUN_SE_REINTENTA: 'oficinaV2.errores.AUN_SE_REINTENTA',
  AGENTE_CERRANDO: 'oficinaV2.errores.AGENTE_CERRANDO',
  SALA_PRINCIPAL: 'oficinaV2.errores.SALA_PRINCIPAL',
  SALA_OCUPADA: 'oficinaV2.errores.SALA_OCUPADA',
  SALA_DESCONOCIDA: 'oficinaV2.errores.SALA_DESCONOCIDA',
  // 09-10 — ordenar las mesas a mano.
  MESA_DESCONOCIDA: 'oficinaV2.errores.MESA_DESCONOCIDA',
  MESA_YA_PUESTA: 'oficinaV2.errores.MESA_YA_PUESTA',
  TOPE_MESAS: 'oficinaV2.errores.TOPE_MESAS',
  MESA_OCUPADA: 'oficinaV2.errores.MESA_OCUPADA',
  ULTIMA_MESA: 'oficinaV2.errores.ULTIMA_MESA',
  AGENTE_DESCONOCIDO: 'oficinaV2.errores.AGENTE_DESCONOCIDO',
  // 04-11 — grupos de mesas (backend/src/oficina/grupos.ts, repo.ts).
  GRUPO_NOMBRE_REPETIDO: 'oficinaV2.errores.GRUPO_NOMBRE_REPETIDO',
  GRUPO_DESCONOCIDO: 'oficinaV2.errores.GRUPO_DESCONOCIDO',
  GRUPO_NO_VALIDO: 'oficinaV2.errores.GRUPO_NO_VALIDO',
  OTRA_SALA: 'oficinaV2.errores.OTRA_SALA',
  // Los que devuelve el socket al escribirle (sendAgentInput): archivado = ya terminó su trabajo.
  AGENT_ARCHIVED: 'oficinaV2.errores.CONTRATADO_CERRADO',
  RUNNER_OFFLINE: 'oficinaV2.errores.RUNNER_OFFLINE',
  // 01-11 — Los contratos con Santi (/api/oficina/pelotas): los de la oficina (aprobacion.ts, index.ts) y los que
  // el centro de pelotas devuelve tal cual (contrato.generated.ts ERRORES; RED/TIEMPO los pone cliente.ts). Sin
  // estos Pau veía «Algo ha fallado en el servidor» para todo, sin saber qué hacer.
  SOLO_PAU: 'oficinaV2.errores.SOLO_PAU',
  SIN_LLAVE: 'oficinaV2.errores.SIN_LLAVE',
  LLAVE_CORTADA: 'oficinaV2.errores.LLAVE_CORTADA',
  PARECE_UN_SECRETO: 'oficinaV2.errores.PARECE_UN_SECRETO',
  NO_TIENES_LA_PELOTA: 'oficinaV2.errores.NO_TIENES_LA_PELOTA',
  TEMA_CERRADO: 'oficinaV2.errores.TEMA_CERRADO',
  IDEMPOTENCIA_REUTILIZADA: 'oficinaV2.errores.IDEMPOTENCIA_REUTILIZADA',
  NO_DISPONIBLE: 'oficinaV2.errores.NO_DISPONIBLE',
  TIEMPO: 'oficinaV2.errores.TIEMPO',
  RED: 'oficinaV2.errores.RED',
  YA_RESUELTA: 'oficinaV2.errores.YA_RESUELTA',
  NO_ENCONTRADO: 'oficinaV2.errores.NO_ENCONTRADO',
  FORBIDDEN: 'oficinaV2.errores.FORBIDDEN',
  PROPUESTA_NO_PENDIENTE: 'oficinaV2.errores.PROPUESTA_NO_PENDIENTE',
} as const;

const textoDe = (code: string) => t((TEXTO as Record<string, (typeof TEXTO)[keyof typeof TEXTO] | undefined>)[code] ?? 'oficinaV2.errores.generico');

/** El `code` que el socket deja en el Error con que rechaza sendAgentInput (no es un ApiHttpError). */
function codigoDeSocket(e: unknown): string | null {
  const code = e instanceof Error ? (e as Error & { code?: unknown }).code : undefined;
  return typeof code === 'string' && code ? code : null;
}

export function mensajeError(e: unknown): string {
  if (e instanceof ApiHttpError) {
    // Bandeja de despliegues: el servidor ya escribe para Pau y con datos que cambian («te quedan 3
    // intentos», «bloqueado hasta las 10:15»): se enseña tal cual.
    // WS15-D4 — «zona ocupada» dice qué agente la tiene (su título): también tal cual.
    if (/^(ALLOW_|CONTRASENA_PANEL_MAL$|ZONA_OCUPADA$)/.test(e.code) && e.message) return e.message;
    return textoDe(e.code);
  }
  // 29-09: escribir al agente va por el socket, que rechaza con un Error normal que lleva `code`
  // (AGENTE_CERRANDO, AGENT_ARCHIVED, RUNNER_OFFLINE…). Antes todo caía en «No hay conexión». Sin `code`
  // (se agotó la espera, no hay socket) sí es la conexión.
  const code = codigoDeSocket(e);
  if (code) return textoDe(code);
  return t('oficinaV2.errores.red');
}

/** ¿Contestó el servidor? Si sí, aquel envío terminó (bien o mal) y un reintento es un envío nuevo. */
export function respondioElServidor(e: unknown): boolean {
  return e instanceof ApiHttpError && e.status !== 0;
}

/**
 * 02-11 — ¿Ese envío a Santi TERMINÓ? Solo si el servidor dijo que no con un 4xx (un secreto, la pelota en el otro
 * lado, otra tarjeta…). Un 5xx de la oficina quiere decir que el centro no contestó: el mensaje PUDO llegar, y el
 * reintento tiene que repetir la MISMA clave para que el centro no lo duplique (lo que se envía a Santi no se borra).
 * Sin respuesta (status 0), lo mismo. Distinto de `respondioElServidor` (que usa la contratación: ahí no hay duplicado).
 */
export function envioTermino(e: unknown): boolean {
  return e instanceof ApiHttpError && e.status >= 400 && e.status < 500;
}

// 02-11 — los contratos con Santi: algunos códigos del centro significan otra cosa que en la oficina (VERSION_DESFASADA
// es «el contrato cambió mientras lo mirabas», no «el plan del agente») y otros no tenían texto (LIMITE, NO_ES_TUYO,
// DEMASIADO_GRANDE, EPOCA_DISTINTA). Lo demás, igual que `mensajeError`.
const TEXTO_PELOTAS = {
  VERSION_DESFASADA: 'oficinaV2.errores.pelotas.VERSION_DESFASADA',
  LIMITE: 'oficinaV2.errores.pelotas.LIMITE',
  NO_ES_TUYO: 'oficinaV2.errores.pelotas.NO_ES_TUYO',
  TABLERO_SIN_CANCELAR: 'oficinaV2.errores.pelotas.TABLERO_SIN_CANCELAR',
  DEMASIADO_GRANDE: 'oficinaV2.errores.pelotas.DEMASIADO_GRANDE',
  EPOCA_DISTINTA: 'oficinaV2.errores.pelotas.EPOCA_DISTINTA',
  // Entrega 3: «Usar en la caja» sobre una propuesta que ya no es la vigente, o que ya no está.
  PROPUESTA_SUSTITUIDA: 'oficinaV2.errores.pelotas.PROPUESTA_SUSTITUIDA',
  SIN_PROPUESTA: 'oficinaV2.errores.pelotas.SIN_PROPUESTA',
} as const;

export function mensajeErrorPelotas(e: unknown): string {
  const code = e instanceof ApiHttpError ? e.code : codigoDeSocket(e);
  const clave = code ? (TEXTO_PELOTAS as Record<string, (typeof TEXTO_PELOTAS)[keyof typeof TEXTO_PELOTAS] | undefined>)[code] : undefined;
  return clave ? t(clave) : mensajeError(e);
}
